import React from 'react';

export default function TeamInfoIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="team_info"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="global/info">
          <mask id="mask-2-team-info" fill="white">
            <path
              d="M12,2 C17.5233333,2 22,6.47666667 22,12 C22,17.5233333 17.5233333,22 12,22 C6.47666667,22 2,17.5233333 2,12 C2,6.47666667 6.47666667,2 12,2 Z M12,4 C7.58123617,4 4,7.58123617 4,12 C4,16.4187638 7.58123617,20 12,20 C16.4187638,20 20,16.4187638 20,12 C20,7.58123617 16.4187638,4 12,4 Z M12,10 C12.5522847,10 13,10.4378814 13,11.0029293 L13,15.9970707 C13,16.5114088 12.6172798,16.9353182 12.1173326,16.9932526 L12,17 C11.4477153,17 11,16.5621186 11,15.9970707 L11,11.0029293 C11,10.4885912 11.3827202,10.0646818 11.8826674,10.0067474 L12,10 Z M12,7 C12.5522847,7 13,7.44771525 13,8 C13,8.55228475 12.5522847,9 12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 Z"
              id="path-1"></path>
          </mask>
          <use
            id="Combined-Shape"
            fill="#42526E"
            fillRule="nonzero"
            href="#path-1"></use>
          <g
            id="Neutral-/-N500-AAA"
            mask="url(#mask-2-team-info)"
            fill="#5E6C84"
            fillRule="evenodd">
            <polygon id="N500" points="0 24 24 24 24 0 0 0"></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
}
